import { render, staticRenderFns } from "./JoinPointCalculate.vue?vue&type=template&id=5875a34f&scoped=true&"
import script from "./JoinPointCalculate.vue?vue&type=script&lang=js&"
export * from "./JoinPointCalculate.vue?vue&type=script&lang=js&"
import style0 from "./JoinPointCalculate.vue?vue&type=style&index=0&id=5875a34f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875a34f",
  null
  
)

export default component.exports